import { loadQuery } from 'react-relay';
import { createResource, useResource } from 'react-resource-router-next';
import RelayEnvironment from './utils';

// Override ResourceStoreContext type

function createCacheKey(query, variables) {
  var queryId = 'cacheID' in query.params ? query.params.cacheID : query.params.id;
  return "relay-".concat(queryId, "-").concat(query.params.name, "-").concat(JSON.stringify(variables !== null && variables !== void 0 ? variables : {}));
}
export var createRelayResource = function createRelayResource(_ref) {
  var getQuery = _ref.getQuery;
  return createResource({
    type: 'RELAY_RESOURCE_TYPE',
    getKey: function getKey(routerContext, customContext) {
      var _getQuery = getQuery(routerContext, customContext),
        query = _getQuery.query,
        variables = _getQuery.variables,
        cacheKey = _getQuery.cacheKey;
      return cacheKey !== null && cacheKey !== void 0 ? cacheKey : createCacheKey(query, variables);
    },
    getData: function getData(routerContext, customContext) {
      var _getQuery2 = getQuery(routerContext, customContext),
        query = _getQuery2.query,
        variables = _getQuery2.variables,
        options = _getQuery2.options;
      var queryReference = loadQuery(RelayEnvironment, query, variables !== null && variables !== void 0 ? variables : {}, options);
      return Promise.resolve(queryReference);
    }
  });
};
export var useRelayResource = function useRelayResource(resource) {
  var _useResource = useResource(resource),
    queryReference = _useResource.data;
  return {
    queryReference: queryReference
  };
};